// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"app-components-staticpages-sidebarlayout--container","textblock":"app-components-staticpages-sidebarlayout--textblock"};